var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c(
        "table",
        {
          staticClass: "col-md-12",
          attrs: { cellspacing: "0", cellpadding: "0" }
        },
        [
          _vm._m(1),
          _c(
            "tbody",
            [
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrayObservacaoProcesso.length == 0,
                      expression: "arrayObservacaoProcesso.length == 0"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "50" } },
                    [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                  )
                ]
              ),
              _vm._l(_vm.arrayObservacaoProcesso, function(obs) {
                return _c("tr", { key: obs.codObservacao }, [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.numSequencia) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.formatarData(obs.datObservacao, "dd/mm/yyyy")
                        ) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.txtObservacao) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.formatarOrigemTela(obs.indOrigemTela)) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.formataStatusProcesso(
                            obs.movimentacaoProcesso.indStatusProcesso
                          )
                        ) +
                        "\n          "
                    )
                  ])
                ])
              })
            ],
            2
          )
        ]
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 col-xs-12" },
        [
          _c("g-timeLine", {
            ref: "refTimeLine",
            attrs: {
              id: "refTimeLine",
              name: "refTimeLine",
              itens: _vm.arrayMovimentacaoProcesso,
              titulo: "Etapas Vencidas por Este Processo",
              conteudo:
                "{n}{p}indStatusProcesso{/p} | {p}datMovimentoFormatada{/p} | {p}setor.unidade.orgao.desOrgao{/p} | {p}setor.unidade.desUnidade{/p} | {n}{p}setor.desSetor{/p}"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "span",
        {
          staticClass:
            "titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12"
        },
        [_vm._v("\n      Observações gerais salvas1\n    ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "5%" } }, [
          _vm._v("Seq.")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "10%" } }, [
          _vm._v("Data")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "70%" } }, [
          _vm._v("Descrição")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "15%" } }, [
          _vm._v("Tela de origem")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "10%" } }, [
          _vm._v("Situação")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }